import { Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AiDefaultToggle } from './AiDefaultToggle';
import { AiUsageTable } from './AiUsageTable';

export function AiSection() {
  const { t } = useTranslation();
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="h3" component="h2" sx={{ mb: 0.5 }}>
        {t('settings.ai.title')}
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
        {t('settings.ai.lead')}
      </Typography>
      <Stack spacing={3}>
        <AiDefaultToggle />
        <AiUsageTable />
      </Stack>
    </Paper>
  );
}
